module.exports = __webpack_public_path__ + "images/patterns/dark/DotsChecker.ca0cf5f242b0ddde494a.svg";